import { render, staticRenderFns } from "./SkillsWithGroupsV2.vue?vue&type=template&id=b291b432&scoped=true&"
import script from "./SkillsWithGroupsV2.vue?vue&type=script&lang=ts&"
export * from "./SkillsWithGroupsV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b291b432",
  null
  
)

export default component.exports